<template>
    <div class="form-field form-file">
        <div class="form-label" v-show="label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">
                <div class="form-file-upload" v-if="uniqueId" v-bind:style="{ width: sizeW }">
                    <input class="input" type="file" :id="uniqueId" @change="upload($event)">
                    <div class="image">
                        <img v-if="!img" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" height="auto"/>
                        <a :href="img" target="_blank" v-if="img" ><img src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" v-bind:style="{ backgroundImage: 'url(' + img + ')' }" height="auto"/></a>
                        <span class="icon icon-icon_picture" v-if="!img"></span>
                        <button class="bt-remove" v-if="img" @click="remove()"><i class="icon icon-icon_close"></i></button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import {Api} from '../../Api.js'

    export default {
        name: 'Upload',
        props: ['value','width','label'],
        data: function () {
            return {
                internalValue: '',
                img: '',
                uniqueId: null
            }
        },
        created: function() {
            let n = Math.floor(Math.random()*11);
            let k = Math.floor(Math.random()* 1000000);
            this.uniqueId = "file-upload-"+String.fromCharCode(n)+k;

            this.internalValue = this.value;
            this.sizeW = this.width ? this.width + "px" : "auto";
            this.get()

            //console.log("dom", document.getElementById( this.uniqueId ));
        },
        methods: {
            upload(e){
                var fileInput = document.getElementById( this.uniqueId );
                var data = new FormData();
                    data.append( 'file', fileInput.files[0] );

                Api().post('media', data).then((response) => {
                    this.internalValue = response.data[0].id
                    this.img = response.data[0].url
                    this.$emit('input', this.internalValue);
                })
            },
            remove(){
                this.img = null
                this.internalValue = null
                this.$emit('input', this.internalValue);
            },
            get(){
                if( this.internalValue ){

                    console.log("get!!!", this.internalValue)

                    Api().get('media/'+this.internalValue).then((response) => {
                        this.img = response.data.url
                    })

                }else{

                }
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
                this.get()
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/File.vue